module.exports = __webpack_public_path__ + "static/media/24.1922287e.jpg";